export default {
  widgetTitleMultiFacteur: 'AUTHENTIFICATION MULTIFACTEUR',
  widgetTitleOktaVerify: 'IDENTIFICATION PAR OKTA VERIFY',
  widgetTitleWindowsHello: 'Windows Hello',
  widgetTitleGoogleAuthenticator: 'IDENTIFICATION PAR GOOGLE AUTHENTICATOR',
  widgetTitlePhoneAuthenticator: 'IDENTIFICATION PAR TÉLÉPHONE',
  widgetTitleBiometricAuthenticator: 'IDENTIFICATION PAR AUTHENTIFIANT BIOMÉTRIQUE',
  widgetTitleAppAuthenticator: 'IDENTIFICATION PAR APPLICATION MOBILE',
  widgetTitleExpiredPassword: 'Mot de passe temporaire',
  widgetTitleConnexion: 'Portail Client',
};
